import { forwardRef, useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AppBar, Box, Dialog, IconButton, Slide, Toolbar, Typography } from '@mui/material'
import DocDisplayPage from './DocDisplayPage'
import TabHeader from '../navigation/TabHeader'
import { AppContext, DashboardContext, DocumentationContext } from '../../context'
import { URLQUERY } from '../../config'
import { useSearchParams } from 'react-router-dom'
import { TransitionProps } from '@mui/material/transitions'
import logoApidDoc from '../../assets/img/apidocs-logo.png'

interface DocDisplayFullScreenProps {
    helpDocument: string
}

const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement; },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function DocDisplayFullScreen({ helpDocument }: DocDisplayFullScreenProps) {
    const appContext = useContext(AppContext)
    const context = useContext(DocumentationContext)
    const dashboardContext = useContext(DashboardContext)
    const [searchParams, setSearchParams] = useSearchParams({})

    useEffect(() => {
        if (!helpDocument) {
            return
        }
        if (searchParams.get(URLQUERY.help)) {
            context?.setReferencedDoc({
                reference: helpDocument,
                title: `Ayuda  ` + (dashboardContext?.navBar.menuSelected?.label || ''),
                withIndex: true,
                fullScreen: true,
                forum: {
                    active: true,
                    selected: 0
                },
                cleanHistory: true
            })
        } else {
            context?.setReferencedDoc(null)
        }
    }, [searchParams, helpDocument])

    return (
        <Dialog
            fullScreen
            open={!!context?.referencedDoc?.fullScreen}
            onClose={() => setSearchParams(undefined)}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative' }} color='inherit'>
                <Toolbar>
                    {!appContext?.loading && <IconButton
                        edge="start"
                        color="inherit"
                        onClick={() => {
                            setSearchParams(undefined)
                            context?.setReferencedDoc(null)
                        }}
                        aria-label="close"
                    >
                        <FontAwesomeIcon icon={'times'} />
                    </IconButton>}
                    <Typography sx={{ ml: 2 }} variant="h6" component="div">
                        {context?.referencedDoc?.title}
                    </Typography>
                    {context?.referencedDoc?.forum?.active && <Box className='d-flex m-auto'>
                        <TabHeader
                            tabsItems={[{ label: 'Contenido', value: 0 }, { label: 'Comentarios', value: 1 }]}
                            onChange={(index) => {
                                if (context.referencedDoc && (index === 1 || index === 0)) {
                                    context?.setReferencedDoc({
                                        ...context?.referencedDoc,
                                        forum: { active: true, selected: index }
                                    })
                                }
                            }}
                            selected={context.referencedDoc.forum.selected}
                        />
                    </Box>}
                    <Box className={`d-flex ${!context?.referencedDoc?.forum?.active && 'm-l-auto'}`}>
                        <img src={logoApidDoc} alt="logo-apidoc" className='help-bar-icon' />
                    </Box>
                </Toolbar>
            </AppBar>
            <section className={`section`}>
                {context?.referencedDoc?.fullScreen && <DocDisplayPage />}
            </section>
        </Dialog>
    )
}
